import { render, staticRenderFns } from "./PopupInfo.vue?vue&type=template&id=29074dd0&"
import script from "./PopupInfo.vue?vue&type=script&lang=js&"
export * from "./PopupInfo.vue?vue&type=script&lang=js&"
import style0 from "./PopupInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports